import AOS from 'aos'
import Tobii from '@midzer/tobii'
import Sticky from 'sticky-js'
import throttle from 'lodash.throttle'
import imagesLoaded from 'imagesloaded'

AOS.init()

const lightboxes = document.getElementsByClassName('lightbox')
if (lightboxes.length > 0) {
  const tobi = new Tobii({ autoplayVideo: true })
}

const sticky1 = new Sticky('.sidebar-scroller')

{
  let scrollpos = window.scrollY
  const header = document.querySelector('.masthead')
  const addClassOnScroll = () => {
    header.classList.add('scrolledHeader')
    scrollpos = window.scrollY
  }
  const removeClassOnScroll = () => {
    header.classList.remove('scrolledHeader')
    scrollpos = window.scrollY
  }
  window.onscroll = throttle(() => {
    const newpos = window.scrollY
    if (newpos >= 150) {
      addClassOnScroll()
    } else if (newpos < 150 && newpos < scrollpos) {
      removeClassOnScroll()
    }
  }, 200)
}

document.addEventListener('DOMContentLoaded', () => {
  // Fade in images when loaded @todo: improve with native lazyloading and animation classes
  const elems = document.querySelectorAll('.images-loaded-fadein')
  if (elems !== null) {
    elems.forEach((elem) => {
      imagesLoaded(elem, { background: true }, function () {
        elem.classList.add('loaded')
      })
    })
  }

  // Homepage hero video play/pause controls
  const homepageVideo = document.querySelector('.homepage-hero .has-video')

  if (homepageVideo !== null) {
    const videoEl = homepageVideo.querySelector('video')
    const controlEl = homepageVideo.querySelector('.button-video-toggle')

    const togglePlayPause = () => {
      const isPlaying = !(videoEl.paused || videoEl.ended)
      controlEl.classList.toggle('is-playing', isPlaying)
      controlEl.classList.toggle('is-paused', !isPlaying)
    }

    controlEl.addEventListener('click', () => {
      if (videoEl.paused || videoEl.ended) {
        videoEl.play()
      } else {
        videoEl.pause()
      }
      togglePlayPause()
    })
  }
})
